var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled from 'styled-components';
import { Button, ProgressBar, WorkflowStepList } from '..';
var TabButtonWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-top: 1rem;\n"])));
var TabWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n"])));
var Wrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: stretch;\n  align-self: stretch;\n  display: flex;\n  justify-content: flex-start;\n"], ["\n  align-items: stretch;\n  align-self: stretch;\n  display: flex;\n  justify-content: flex-start;\n"])));

var Workflow =
/** @class */
function (_super) {
  __extends(Workflow, _super);

  function Workflow() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      current: 0
    };

    _this.next = function () {
      var current = _this.state.current;
      var tabCount = _this.props.tabs.length - 1;
      var next = current === tabCount ? current : current + 1;

      _this.navigate(next);
    };

    _this.prev = function () {
      var current = _this.state.current;
      var prev = current === 0 ? current : current - 1;

      _this.navigate(prev);
    };

    return _this;
  }

  Workflow.prototype.getProgressCategory = function (category, floor) {
    if (floor === void 0) {
      floor = true;
    }

    var categorySteps = this.props.tabs.filter(function (tab) {
      return tab.props.brand === category;
    });
    var categoryPercent = categorySteps.length / this.props.tabs.length * 100;
    return floor ? Math.floor(categoryPercent) : Math.ceil(categoryPercent);
  };

  Workflow.prototype.getProgressBar = function () {
    var categories = [{
      brand: 'success',
      name: 'success',
      title: 'Valid',
      value: this.getProgressCategory('success', false)
    }, {
      brand: 'danger',
      name: 'danger',
      title: 'Invalid',
      value: this.getProgressCategory('danger')
    }, {
      brand: 'warning',
      name: 'warning',
      title: 'Warning',
      value: this.getProgressCategory('warning')
    }, {
      brand: 'info',
      name: 'info',
      title: 'Info',
      value: this.getProgressCategory('info')
    }];
    return React.createElement(ProgressBar, {
      categories: categories
    });
  };

  Workflow.prototype.getStepList = function () {
    var _this = this;

    var stepList = this.props.tabs.map(function (tab, i) {
      return {
        brand: tab.props.brand,
        connect: !!i,
        current: _this.state.current === i,
        id: i.toString(),
        name: tab.props.name,
        onClick: function onClick() {
          return _this.navigate(i);
        },
        disabled: _this.getStepDisabled(i)
      };
    });
    return React.createElement(WorkflowStepList, {
      steps: stepList
    });
  };

  Workflow.prototype.getStepDisabled = function (i) {
    var stepLen = this.props.tabs.length - 1;
    var finalPageLocksFlow = this.props.finalPageLocksFlow;
    var retVal = false;

    if (finalPageLocksFlow) {
      if (i < stepLen) {
        retVal = !this.allowedNavigate(i);
      } else if (this.props.finalPageCheck) {
        retVal = !this.props.finalPageCheck();
      }
    }

    return retVal;
  };

  Workflow.prototype.getCurrentTab = function () {
    return this.props.tabs[this.state.current];
  };

  Workflow.prototype.allowedNavigate = function (i) {
    var retVal = this.props.allowedNavigate === undefined || this.props.allowedNavigate(i);

    if (i < 0) {
      return false;
    }

    var current = this.state.current;
    var stepLen = this.props.tabs.length - 1;
    var finalPageLocksFlow = this.props.finalPageLocksFlow;

    if (finalPageLocksFlow) {
      if (current === stepLen) {
        return false;
      } else if (i === stepLen && this.props.finalPageCheck) {
        return retVal && this.props.finalPageCheck();
      } else {
        return retVal && true;
      }
    } else {
      return retVal && i < stepLen + 1;
    }
  };

  Workflow.prototype.navigate = function (i) {
    if (this.allowedNavigate(i)) {
      this.setState(__assign(__assign({}, this.state), {
        current: i
      }));
      this.props.handleTabChange && this.props.handleTabChange(i);
    }
  };

  Workflow.prototype.render = function () {
    var finalButton = this.props.finalButton;
    var current = this.state.current;
    var stepLen = this.props.tabs.length - 1;
    return React.createElement(Wrapper, {
      className: "workflow row"
    }, React.createElement("div", {
      className: "workflow-wrapper col-4"
    }, this.getProgressBar(), this.getStepList()), React.createElement(TabWrapper, {
      className: "workflow-tab-wrapper col-8"
    }, this.getCurrentTab(), React.createElement(TabButtonWrapper, {
      className: "workflow-tab-buttons"
    }, this.allowedNavigate(current - 1) ? React.createElement(Button, {
      brand: "lowContrast",
      onClick: this.prev
    }, "Back") : React.createElement("span", null), this.allowedNavigate(current + 1) ? React.createElement(Button, {
      brand: "primary",
      onClick: this.next
    }, current === stepLen - 1 ? this.props.penUltimateButton || 'Next' : 'Next') : React.createElement("span", null), current === stepLen && finalButton)));
  };

  return Workflow;
}(React.Component);

export default Workflow;
var templateObject_1, templateObject_2, templateObject_3;